export default __webpack_public_path__ + "static/media/icon-question.1aeb1fff.svg";